import React from 'react';
import useWindowDimensions from '../../theme/useWindowDimensions';
import { Toaster } from 'react-hot-toast';

function LoaderContainer({ text, children }) {
  const { height, width } = useWindowDimensions();

  return (
    <div
      style={{
        height: height - 1,
        width: width - 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'ThreeDFace',
        backgroundColor: '#11091E',
      }}
    >
      <>{children}</>
      {text ? <p>{text}</p> : null}
      <Toaster position='top-center'></Toaster>
    </div>
  );
}

export default LoaderContainer;
